/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PhotoContainer_photoQuery = {
    readonly " $fragmentRefs": FragmentRefs<"SocialIconOverlay_photoQuery">;
    readonly " $refType": "PhotoContainer_photoQuery";
};
export type PhotoContainer_photoQuery$data = PhotoContainer_photoQuery;
export type PhotoContainer_photoQuery$key = {
    readonly " $data"?: PhotoContainer_photoQuery$data;
    readonly " $fragmentRefs": FragmentRefs<"PhotoContainer_photoQuery">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PhotoContainer_photoQuery",
  "type": "TradePhotosQueryOutput",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SocialIconOverlay_photoQuery",
      "args": null
    }
  ]
};
(node as any).hash = '06b1f6ec9cb412cf66145d5b9749128b';
export default node;
